/**
 * BST FAQ Page — tabs across header + category sections, accordions
 */
(function () {
  'use strict';

  const ACTIVE_CLASS = 'is-active';
  const OPEN_CLASS = 'is-open';

  function setAccordionOpen(item, open) {
    const trigger = item.querySelector('[data-bst-faq-trigger]');
    const answer = item.querySelector('[data-bst-faq-answer]');

    item.classList.toggle(OPEN_CLASS, open);
    if (trigger) trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (answer) {
      if (open) {
        answer.removeAttribute('inert');
      } else {
        answer.setAttribute('inert', '');
      }
    }
  }

  function bindAccordions(scope, singleOpen) {
    scope.querySelectorAll('[data-bst-faq-accordion]').forEach((group) => {
      if (group._bstFaqAccordionInit) return;
      group._bstFaqAccordionInit = true;

      group.addEventListener('click', (event) => {
        const trigger = event.target.closest('[data-bst-faq-trigger]');
        if (!trigger || !group.contains(trigger)) return;

        const item = trigger.closest('[data-bst-faq-item]');
        if (!item || !group.contains(item)) return;

        const isOpen = item.classList.contains(OPEN_CLASS);

        if (singleOpen && !isOpen) {
          group.querySelectorAll('[data-bst-faq-item].is-open').forEach((other) => {
            if (other !== item) setAccordionOpen(other, false);
          });
        }

        setAccordionOpen(item, !isOpen);
      });
    });
  }

  function getPanels() {
    return Array.from(document.querySelectorAll('[data-bst-faq-category-panel]'));
  }

  function activateTab(tabKey) {
    document.querySelectorAll('[data-bst-faq-tab]').forEach((tab) => {
      const isActive = tab.dataset.bstFaqTab === tabKey;
      tab.classList.toggle(ACTIVE_CLASS, isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    getPanels().forEach((panel) => {
      const isActive = panel.dataset.bstFaqCategoryPanel === tabKey;
      panel.classList.toggle(ACTIVE_CLASS, isActive);
    });
  }

  function bindTabs(root) {
    const tabs = root.querySelectorAll('[data-bst-faq-tab]');
    if (!tabs.length) return;

    const panels = getPanels();
    if (!panels.length) return;

    const panelKeys = new Set(panels.map((panel) => panel.dataset.bstFaqCategoryPanel));
    const validTabs = Array.from(tabs).filter((tab) => panelKeys.has(tab.dataset.bstFaqTab));
    if (!validTabs.length) return;

    const initial =
      root.querySelector('[data-bst-faq-tab].is-active')?.dataset.bstFaqTab ||
      validTabs[0].dataset.bstFaqTab;

    activateTab(initial);

    validTabs.forEach((tab) => {
      tab.addEventListener('click', () => activateTab(tab.dataset.bstFaqTab));

      tab.addEventListener('keydown', (event) => {
        const keys = ['ArrowRight', 'ArrowLeft', 'Home', 'End'];
        if (!keys.includes(event.key)) return;

        event.preventDefault();
        const index = validTabs.indexOf(tab);
        let nextIndex = index;

        if (event.key === 'ArrowRight') nextIndex = (index + 1) % validTabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + validTabs.length) % validTabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = validTabs.length - 1;

        validTabs[nextIndex]?.focus();
        activateTab(validTabs[nextIndex].dataset.bstFaqTab);
      });
    });
  }

  function applyOpenFirst(root) {
    if (root.dataset.openFirst !== 'true') {
      document.querySelectorAll('[data-bst-faq-item].is-open').forEach((item) => setAccordionOpen(item, false));
    }
  }

  function initPage(root) {
    if (root._bstFaqPageInit) return;
    root._bstFaqPageInit = true;

    const singleOpen = root.dataset.singleOpen === 'true';

    getPanels().forEach((panel) => bindAccordions(panel, singleOpen));
    bindTabs(root);
    applyOpenFirst(root);
  }

  function init() {
    document.querySelectorAll('[data-bst-faq-page]').forEach(initPage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
